import { useRef, MouseEvent, ReactNode } from 'react'
import ImagePreloader from '@/app/util/image-preloader'
import { INFO_IMAGE_URLS } from '../../config/constants'
import { useAboutPageContext } from '../../context'
import { cn } from '@/util/cn'

type Props = {
    hoverId: keyof typeof INFO_IMAGE_URLS
    className?: string
    children?: ReactNode
}

const AboutPageHoverItem = ({ children, hoverId, className }: Props) => {
    const { addHoverImage } = useAboutPageContext()
    const imageIndexRef = useRef<number>(0)
    const imageUrls = INFO_IMAGE_URLS[hoverId] || []

    const onMouseOver = async (e: MouseEvent) => {
        if (!imageUrls.length) return
        const imageUrl: string = imageUrls[imageIndexRef.current]

        await ImagePreloader.load([imageUrl])

        addHoverImage({
            url: imageUrl,
            x: e.clientX,
            y: e.clientY,
        })

        imageIndexRef.current++

        if (imageIndexRef.current >= imageUrls.length) {
            imageIndexRef.current = 0
        }
    }
    return (
        <span className={cn('cursor-pointer font-normal underline', className)} onMouseOver={onMouseOver}>
            {children}
        </span>
    )
}

export default AboutPageHoverItem
